<template>
  <div class="unauthorized">
    <h1>Acceso No Autorizado</h1>
    <p>No tienes permisos para acceder a esta sección.</p>
    <router-link to="/dashboard">Volver al inicio</router-link>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized'
};
</script>

<style scoped>
.unauthorized {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}
</style>